module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/preview_de-8394f35ea0ba57b6633f186b0e167b5d.png";